import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { tipText } from '../../../smoothr-web-app-core/utils/utils';
import { ModalController } from '@ionic/angular';
import { AbsoluteTipInputModalComponent } from '../../modals/absolute-tip-input-modal/absolute-tip-input-modal.component';

export enum TipType {
	ABSOLUTE = 'absolute',
	RELATIVE = 'relative',
}

export interface TipSelectorValue {
	value: number;
	type: TipType;
	icon: string;
}

@Component({
	selector: 'app-tip-selector',
	standalone: false,
	templateUrl: './tip-selector.component.html',
	styleUrls: ['./tip-selector.component.scss'],
})
export class TipSelectorComponent {
	@Input() totalPrice = 0; // base total as number
	@Input() itemCount = 0; // number of articles
	@Input() tips: TipSelectorValue[] = [
		{
			value: 8,
			type: TipType.RELATIVE,
			icon: '☺️',
		},
		{
			value: 10,
			type: TipType.RELATIVE,
			icon: '😀',
		},
		{
			value: 12,
			type: TipType.RELATIVE,
			icon: '😍',
		},
	]; // available percentages
	@Input() selectedTip: TipSelectorValue = {
		value: 0,
		type: TipType.RELATIVE,
		icon: '',
	};

	@Output() tipChange = new EventEmitter<TipSelectorValue>();

	private repositoryService = inject(RepositoryService);
	private modalCtrl = inject(ModalController);

	selectTip(value: TipSelectorValue) {
		this.selectedTip = value;
		this.tipChange.emit(value);
	}

	async selectAbsolute() {
		const result = await AbsoluteTipInputModalComponent.show(this.modalCtrl);
		if (!result || Number.isNaN(result.value) || !Number.isFinite(result.value)) {
			return;
		}
		this.selectTip(result);
	}

	noTip() {
		this.selectedTip = { value: 0, type: TipType.RELATIVE, icon: '' };
		this.tipChange.emit({
			value: 0,
			type: TipType.RELATIVE,
			icon: '',
		});
	}

	text(value: TipSelectorValue | null): string {
		return tipText(this.repositoryService.currencyFormat, value);
	}

	absoluteText(value: TipSelectorValue | null): string {
		if (!value || value.type !== TipType.ABSOLUTE) return '€?';
		return this.repositoryService.currencyFormat.format(value.value);
	}

	selectedIsAbsolute(): boolean {
		return this.selectedTip.type === TipType.ABSOLUTE;
	}
}
